import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/Leaderboard.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function Leaderboard() {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(`${API_BASE_URL}/leaderboard`);
      if (response.data.success) {
        setLeaderboard(response.data.leaderboard);
      }
    } catch (err) {
      console.error('Error fetching leaderboard:', err);
      setError('Failed to load leaderboard');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="leaderboard-container">
        <h2 className="leaderboard-title">Leaderboard</h2>
        <div className="leaderboard-loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="leaderboard-container">
        <h2 className="leaderboard-title">Leaderboard</h2>
        <div className="leaderboard-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="leaderboard-container">
      <div className="leaderboard-header">
        <h2 className="leaderboard-title">Leaderboard</h2>
        <button className="leaderboard-refresh" onClick={fetchLeaderboard} title="Refresh">
          ↻
        </button>
      </div>
      <div className="leaderboard-list">
        {leaderboard.length === 0 ? (
          <div className="leaderboard-empty">No participants yet</div>
        ) : (
          leaderboard.map((entry) => (
            <div key={`${entry.city}-${entry.country}`} className="leaderboard-item">
              <div className="leaderboard-rank">#{entry.rank}</div>
              <div className="leaderboard-city-info">
                <div className="leaderboard-city-name">{entry.city}</div>
                {entry.country && (
                  <div className="leaderboard-country">{entry.country}</div>
                )}
              </div>
              <div className="leaderboard-count">
                <div className="leaderboard-total">{entry.totalCount}</div>
                <div className="leaderboard-label">participants</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Leaderboard;

